import { InjectionToken } from "@angular/core";

export const MSAL_CONFIG = new InjectionToken<string>("MSAL_CONFIG");
export const MSAL_CONFIG_ANGULAR = new InjectionToken<string>("MSAL_CONFIG_ANGULAR");
